import Facility from "@/modules/book/data/facility";
import TechnicalInfo from "@/modules/book/data/technical-info";

export default class FacilityOverview {
  facility = new Facility();
  technicalInfo = new TechnicalInfo();
  facilityDocumentations = [];
  facilityUserAssignments = [];

  ownerName = "";
  operatorName = "";
  managerName = "";

  countryName = "";
  provinceName = "";

  manufacturerName = "";
  assemblerName = "";

  constructor() {
  }
}